import React, { useEffect, useState } from 'react';
import TrainingService from '../../Service/TrainingService';
import image_croix from "../Pages/image/croix.png";

const TrainingCompetence = ({ training }) => {
    const [editMode, setEditMode] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const token = sessionStorage.getItem('token');

    // Convertir le HTML en texte brut au moment de l'édition
    useEffect(() => {
        console.log(training.competence);
        
        if (training.competence) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = training.competence;  // Le texte initial est en HTML
            setTextAreaValue(tempDiv.innerText);  // Convertir le HTML en texte brut pour l'édition
        }
    }, [training.competence]);

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleInputChange = (event) => {
        setTextAreaValue(event.target.value);
    };

    const handleSaveClick = async () => {
        // Sauvegarder le texte modifié dans l'objet training
        training.competence = textAreaValue;  // Le texte modifié reste en texte brut

        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(training);
            } else {
                response = await TrainingService.postModifTraining(training);
            }
            window.location.reload();
            console.log(response);
        } catch (error) {
            console.log("Error: " + error);
        }
        setEditMode(false);
    };

    // Séparer le texte par les tirets "-" et ajouter une croix avant chaque ligne
    const getLinesWithIcons = (text) => {
        return text.split(/\n/).map((line, index) => (
            line.trim().startsWith('-') ? (
                <div className="line" key={index}>
                    <img src={image_croix} alt="Presentation icon" className="section-icon" />
                    <span>{line.trim().substring(1).trim()}</span> {/* Retirer le "-" */}
                </div>
            ) : (
                <div className="line" key={index}>
                    <span>{line.trim()}</span>
                </div>
            )
        ));
    };

    return (
        <div className="course-content">
            <h3>A la fin de la certification le candidat dispose des connaissances et compétences suivantes :</h3>
            <div className="certif">
                <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/e2bee865d37e2bdb46b5c3e6320f314f1d4048dcceb16f10a8b433f5a6fa4954?apiKey=59156c16963f46e28d2e0d857e2bfa45&"
                    className="profile-image"
                    alt="Profile"
                />
            </div>

            {editMode ? (
                // Mode édition : afficher le texte dans un textarea pour le modifier
                <textarea
                    value={textAreaValue}
                    onChange={handleInputChange}
                    rows={10}
                    style={{ width: '100%' }}
                />
            ) : (
                // Mode affichage : afficher chaque ligne avec ou sans icône de croix selon la condition
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {getLinesWithIcons(textAreaValue)}
                </div>
            )}

            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={handleEditClick}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
        </div>
    );
};

export default TrainingCompetence;